// extracted by mini-css-extract-plugin
export var standaloneTable = "_cd-0";
export var standaloneTableWithBodyFill = "_cd-1";
export var withExtraHeader = "_cd-2";